module.exports = __webpack_public_path__ + "hero2.png?0cb2dac64cfb2f29754522fbe78e0515";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/hero2.png
// module id = 335
// module chunks = 0